function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.447 5.91v.75h1.593a1.783 1.783 0 0 1 1.783 1.783v6.754a1.783 1.783 0 0 1-1.783 1.783H4.221a1.783 1.783 0 0 1-1.783-1.783V5.066a1.783 1.783 0 0 1 1.783-1.783h8.443a1.783 1.783 0 0 1 1.783 1.783v.844Zm-.939.75h.75V5.066a1.594 1.594 0 0 0-1.594-1.594H4.221a1.594 1.594 0 1 0 0 3.188h9.287Zm3.377 6.755h.75v-3.189h-1.594a1.594 1.594 0 1 0 0 3.188h.844Zm0-3.378h.75V8.443a1.594 1.594 0 0 0-1.594-1.594H4.221c-.203 0-.404-.034-.595-.101l-.999-.352v8.801a1.594 1.594 0 0 0 1.594 1.595h11.82a1.594 1.594 0 0 0 1.594-1.595v-1.594h-1.594a1.783 1.783 0 0 1 0-3.566h.844Z",
  fill: "#E6E6E6",
  stroke: "#FFF",
  strokeWidth: 1.5
});

function SvgIconWallet(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWallet);
export default __webpack_public_path__ + "static/media/icon-wallet.d0ae743531c2c94f4a02b0024b8adbe4.svg";
export { ForwardRef as ReactComponent };